import { render } from "./Days.vue?vue&type=template&id=0d3e13d0"
import script from "./Days.vue?vue&type=script&lang=js"
export * from "./Days.vue?vue&type=script&lang=js"

import "./Days.vue?vue&type=style&index=0&id=0d3e13d0&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__